.TextArea {
  width: 100%;
  font-family: inherit;
  font-size: inherit;
  color: inherit;
  resize: both;
  background-color: transparent;
  border: 0;
  appearance: none;
}

.TextArea:focus {
  outline: 0;
}

.TextArea[data-resize='none'] {
  resize: none;
}

.TextArea[data-resize='both'] {
  resize: both;
}

.TextArea[data-resize='horizontal'] {
  resize: horizontal;
}

.TextArea[data-resize='vertical'] {
  resize: vertical;
}

.TextArea:disabled {
  resize: none;
}

.CharacterCounter {
  display: flex;
  align-items: center;
  gap: var(--control-xsmall-gap);
  color: var(--fgColor-muted);
}

.CharacterCounter--error {
  color: var(--fgColor-danger);
}
